import { InputOfficeDropdown } from '~/commonComponents';
import { IOptionValue } from '~/commonComponents/Autocomplete/interfaces';

import { CollapsibleRow } from '../CollapsibleRow/CollapsibleRow';
import { Title } from '../CollapsibleRow/Title';
import { SolidHomeHouseIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

interface ISelectOfficeRowProps {
  value: string;
  onChange: (value: string | undefined) => void;
}

export const SelectOfficeRow = ({ value, onChange }: ISelectOfficeRowProps) => {
  const handleOnChange = (item: IOptionValue<string> | undefined) => {
    onChange(item?.value);
  };

  return (
    <CollapsibleRow
      disabled
      TitleComponent={() => <Title text="Office:" isRequired />}
      ValueComponent={() => (
        <div style={{ marginRight: -28, width: '65%' }}>
          <InputOfficeDropdown
            value={value}
            onChange={handleOnChange}
            placeholder="Select Office"
          />
        </div>
      )}
      icon={<SolidHomeHouseIcon size={24} color={colors.secondary[500]} />}
    />
  );
};
